import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { wacoConfig } from "./data";

export default function WacoPage() {
  return <CityPageTemplate config={wacoConfig} />;
}